import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'string',
    standalone: true,
})
export class StringPipe implements PipeTransform {
    transform(value: unknown, radix = 10): string {
        if (value == null || value === undefined) {
            return '';
        }

        return typeof value === 'number'
            ? value.toString(radix)
            : String(value);
    }
}
